//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ReportCheckListText from './ReportCheckListText.vue'
import CardSeparator from '../../../../components/Card/CardSeparator.vue'
import DateTimeField from '../../../../components/Field/DateTimeField.vue'
import { axiosGet, axiosPost } from '../../../../axios/axios.js'
import { EventBus } from '../../../../EventBus/EventBus.js'

export default {
  components: {
    ReportCheckListText,
    CardSeparator,
    DateTimeField
  },
  props: {
    report: {
      type: Object,
      required: true
    },
    technologicalOperation: {
      type: Object,
      required: true
    },
    resultName: {
      type: String,
      default: ''
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loading: false,
      actualizationLoading: false,
      additionalRules: [val => (val === '' || /^[a-zа-ё0-9]+$/i.test(val)) || 'Серийный номер должен состоять только из цифр и букв']
    }
  },
  computed: {
    hasSupTask: function () {
      const supTaskVersions = this.report && this.report.supTaskData && this.report.supTaskData.supTask || null
      return !!(supTaskVersions && supTaskVersions.length)
    },
    supBeacon: function () {
      const supBeaconVersions = this.report && this.report.supTaskData && this.report.supTaskData.supBeacon || null
      return supBeaconVersions && supBeaconVersions.length ? supBeaconVersions[supBeaconVersions.length - 1] : {}
    },
    supBeaconDataChanged: function () {
      if (this.supBeacon.updateTime != null && this.report && this.report.creationTime != null) {
        return this.supBeacon.updateTime > this.report.creationTime + 60000
      }
      return false
    },
    serialNumber: function () {
      return this.resultValue ? this.resultValue.value || null : null
    },
    supBeaconSerialNumber: function () {
      return this.supBeacon.serial || null
    },
    supBeaconSerialNumberMismatch: function () {
      return this.hasSupTask && this.serialNumber !== this.supBeaconSerialNumber
    },
    objectSerialNumberShown: function () {
      return this.resultValue.objectValue !== undefined && (this.roleExecutor ? this.resultValue.hide !== true : true) && this.state !== 'PR7'
    },
    objectSerialNumber: function () {
      return this.resultValue.objectValue || null
    },
    objectSerialNumberMismatch: function () {
      return this.objectSerialNumberShown && this.serialNumber !== this.objectSerialNumber
    },

    resultNotification: function () {
      let resultClass = null
      if (this.serialNumber && this.supBeaconSerialNumberMismatch) {
        if (this.supBeaconSerialNumber) {
          resultClass = 'check-list_beacon-serial-number-field--invalid'
        } else {
          resultClass = 'check-list_beacon-serial-number-field--warning'
        }
      } else if (!this.serialNumber && (this.objectSerialNumberMismatch || this.supBeaconSerialNumberMismatch)) {
        resultClass = 'check-list_beacon-serial-number-field--warning'
      }
      return {
        class: resultClass,
        showObjectText: this.serialNumber && this.objectSerialNumberMismatch,
        showSupBeaconText: this.supBeaconSerialNumberMismatch
      }
    },
    objectNotification: function () {
      if (this.serialNumber && this.objectSerialNumberMismatch) {
        return { class: 'check-list_beacon-serial-number-field--blue', showText: true }
      }
      return null
    },
    supBeaconNotification: function () {
      if (this.supBeaconSerialNumberMismatch) {
        return { class: 'check-list_beacon-serial-number-field--invalid', showText: true }
      }
      return null
    },

    serialNumberRequired: function () {
      return !!(!this.readonly && this.technologicalOperation.required && this.technologicalOperation.resultsRequired)
    },
    updateSupTaskDataAvailable: function () {
      return !!(this.report && this.report.supTaskData && this.report.supTaskData.updateAvailable)
    },

    supTask: function () {
      const recordVersions = this.report && this.report.supTaskData && this.report.supTaskData.supTask || null
      return recordVersions && recordVersions.length ? recordVersions[recordVersions.length - 1] : null
    },
    mobileDevice: function () {
      return document.body.classList.contains('mobile') || document.body.classList.contains('native-mobile')
    },
    beaconAppURL: function () {
      if (this.mobileDevice && this.supTask && this.supTask.number != null) {
        return 'beaconapp://task/' + this.supTask.number
      }
      return null
    }
  },
  watch: {
    resultValue: {
      handler: function () {
        this.$nextTick(() => this.validate())
      },
      immediate: true
    }
  },
  mounted: function () {
    this.validate()
  },
  methods: {
    validate: function () {
      if (this.$refs.field && this.$refs.field.$refs.field) {
        this.$refs.field.$refs.field.validate()
      }
    },

    onUpdateSupTaskData: function () {
      const params = new URLSearchParams()
      params.append('id', this.report.requestId[this.report.id])
      params.append('reportId', this.report.requestId[this.report.id])
      params.append('includeActions', false)

      this.loading = true
      return axiosGet({
        url: '/service/delta/request/updateSupTaskData?' + params.toString(),
        onSuccess: (response) => {
          // if (response.data.updated) {
          const supTaskData = response.data.result
          this.report.supTaskData = supTaskData

          this.$q.notify({
            type: 'positive',
            message: response.data && response.data.message || 'Интеграционные данные успешно обновлены',
            progress: true,
            timeout: 3000
          })
          // } else {
          //   this.$q.notify({
          //     type: 'warning',
          //     message: 'Нет изменений',
          //     progress: true,
          //     timeout: 3000
          //   })
          // }
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response && response.message || 'Ошибка обновления интеграционных данных',
            progress: true,
            timeout: 3000
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onActualizeBeaconSerialNumberFromQR: function () {
      const params = new URLSearchParams()
      params.append('objectId', this.report.id)

      this.actualizationLoading = true
      return axiosPost({
        url: '/service/delta/report/actualizeBeaconSerialNumberFromQR?' + params.toString(),
        onSuccess: (response) => {
          // const supTaskData = response.data.result
          // this.report.supTaskData = supTaskData

          // this.$q.notify({
          //   type: 'positive',
          //   message: response.data && response.data.message || 'Серийный номер успешно обновлен',
          //   progress: true,
          //   timeout: 3000
          // })

          EventBus.$emit('report-updated')
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response && response.message || 'Ошибка обновления серийного номера по фото отчёта',
            progress: true,
            timeout: 3000
          })
        }
      }).finally(() => {
        this.actualizationLoading = false
      })
    }
  }
}

